<template>
    <div >
      <div ref="slideCarousel" class="carousel-container" style="overflow: hidden;">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls" :key="item.index">
            <img @click="handleClick(item.linkUrl)" class="advertise-img" :src="preText + item.coverImgUrlPC">
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="qrcode-part">
        <img class="qrcode-img" :src="preText + '/assets/~/media/images/community/qrcode-app.jpg'">
        <img class="qrcode-img" :src="preText + '/assets/~/media/images/community/qrcode-miniprogram.jpg'">
    </div>
    </div>
  </template>
  
  <script>
  import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
  import Swiper from "swiper";
  
  export default {
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
        showFullVideo: false, // 是否显示完整视频
        observer: null, // 可见性监听器
        activeSlideIndex: 0, // 记录当前 swiper 索引
        imgUrls: [
          {
            index: 0,
            coverImgUrlPC:'/assets/~/media/images/community/ad-1.jpg',
            linkUrl:'https://www.kia.cn/vehicles/new-sportage/',
          },
          {
            index: 2,
            coverImgUrlPC:'/assets/~/media/images/community/ad-2.jpg',
            linkUrl:'https://www.kia.cn/vehicles/kx1/',
          },
          {
            index: 3,
            coverImgUrlPC:'/assets/~/media/images/community/ad-3.jpg',
            linkUrl:'https://www.kia.cn/vehicles/thenewk3/',
          },
        ],
        
      }
    },
    mounted() {
      if (!window.location.href.includes("https://www.kia.cn")) {
        this.preText = 'https://uat.kia.cn'
      }else{
        this.preText = 'https://www.kia.cn'
      }
      // this.slideBanner()
      window.addEventListener("resize", this.setResize);
  
      this.$nextTick(()=>{
          this.swiper = new Swiper(".carousel-container", {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              // sliderPerview: 'auto',
              // loopAdditionalSlides: 5,
              loopFillGroupWithBlank: false,
              autoplayDisableOnInteraction : false,
              autoplay: {
                  delay: 5000,
                   disableOnInteraction: false,
              },
              pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
              },
              navigation: {
                nextEl: "#swiper-button-next",
                prevEl: "#swiper-button-prev",
              },
              on: {
                slideChangeTransitionStart: this.slideChangeTransitionEnd,
              },
          });
      })
  
    },
    methods: {
      handleClick(linkUrl) {
        window.open(linkUrl, '_blank');
      }
    },
  }
  </script>
  <style  lang="scss" scoped>
  @import "swiper/css/swiper.css";
  //pc start
  @media (min-width: 767px) {
    
    .swiper-pagination{
      width: 88%;
      height: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      transform: translateY(-20px);
    }
    .qrcode-part {
        width:100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
    }
    .qrcode-img {
      width: 49%;
      border-radius: 5px;
    }
    /* progressbar pagination (no bullets) */
    ::v-deep .swiper-pagination-progressbar {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 0;
      position: relative;
    }
    ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      background: rgba(255, 255, 255, 1);
      border-radius: 0;
    }
    .carousel-container {
        width: 100%;
        // height: calc(662 / 1920 * 100vw);
        border-radius: 5px;
    }
    .swiper-slide {
        position: relative;
        text-align: center;
    }
    .advertise-img {
        width: 100%;
        height: auto;
        display: block;
        cursor: pointer;
    }
  }
  //pc end
  </style>
  